/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dark_Bad_Cow_PatInputs */

const en_dark_bad_cow_pat = /** @type {(inputs: Dark_Bad_Cow_PatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry could not be loaded.`)
};

const de_dark_bad_cow_pat = /** @type {(inputs: Dark_Bad_Cow_PatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintrag konnte nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "Entry could not be loaded." |
*
* @param {Dark_Bad_Cow_PatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dark_bad_cow_pat = /** @type {((inputs?: Dark_Bad_Cow_PatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dark_Bad_Cow_PatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dark_bad_cow_pat(inputs)
	return de_dark_bad_cow_pat(inputs)
});